import { useTranslation } from 'react-i18next';
import { Link } from '@inertiajs/react';
import { Card } from '../ui';
import FrequencyBadge from './FrequencyBadge';
import TierBadge from './TierBadge';
import PosBadge from './PosBadge';
import { cn } from '../../lib/cn';

export default function WordCard({ word, variant = 'card', className }) {
  const { t } = useTranslation();
  if (variant === 'list') {
    return (
      <Link href={`/teacher/dictionary/${word.id}`} className={cn('block', className)}>
        <Card className="p-4 hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="text-lg font-semibold text-gray-900 dark:text-white">
                {word.lemma}
              </span>
              <PosBadge pos={word.pos} size="sm" />
            </div>
            <div className="flex items-center gap-2">
              <FrequencyBadge band={word.frequencyBand} size="sm" />
              <TierBadge tier={word.beckTier} size="sm" />
            </div>
          </div>
          {word.primaryDefinition && (
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-2 line-clamp-2">
              {word.primaryDefinition}
            </p>
          )}
        </Card>
      </Link>
    );
  }

  return (
    <Link href={`/teacher/dictionary/${word.id}`} className={cn('block', className)}>
      <Card className="p-5 h-full hover:shadow-md transition-shadow">
        <div className="flex items-start justify-between mb-3">
          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              {word.lemma}
            </h3>
            {word.ipa && (
              <span className="text-sm text-gray-500 dark:text-gray-400 font-mono">
                /{word.ipa}/
              </span>
            )}
          </div>
          <FrequencyBadge band={word.frequencyBand} size="sm" />
        </div>
        <div className="flex items-center gap-2 mb-3">
          <PosBadge pos={word.pos} size="sm" />
          <TierBadge tier={word.beckTier} size="sm" />
        </div>
        {word.primaryDefinition && (
          <p className="text-sm text-gray-600 dark:text-gray-400 line-clamp-3">
            {word.primaryDefinition}
          </p>
        )}
        {word.familyHeadword && (
          <p className="text-xs text-gray-400 dark:text-gray-500 mt-2">
            {t('dictionary.family', { headword: word.familyHeadword })}
          </p>
        )}
      </Card>
    </Link>
  );
}
